<template>
  <v-breadcrumbs
    :dark="$vuetify.theme.isDark"
    :key="this.$route.path"
    class="pa-0"
    :items="breadcrumbs?.trail"
  >
    <template v-slot:item="{ item, index }">
      <v-breadcrumbs-item
        :key="item.text"
        :to="item.to || undefined"
        :disabled="item.disabled || !item.to"
        exact
      >
        <span class="text-body-2 font-weight-bold text-capitalize">{{
          item.text
        }}</span>
      </v-breadcrumbs-item>
    </template>
  </v-breadcrumbs>
</template>

<script>
export default {
  name: "Breadcrumbs",
  computed: {
    breadcrumbs() {
      let result = this.$route.matched.map((route) => {
        let trail = route.meta.trail(this.$route);
        return {
          text: route.meta.text,
          disabled: false,
          to: route.path,
          trail: trail.map((item, index) => {
            return {
              text: item.text,
              to: item.to || undefined,
              disabled: item.disabled !== undefined ? item.disabled : !item.to,
            };
          }),
        };
      });
      return result[0];
    },
  },
};
</script>
